"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgPumpMcOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M30 19.87V7H20V4h-2v3H9.55a4.65 4.65 0 00-3.71 1.3C4.71 9.42 4.09 11.39 4 14H2v2h2.07a7.52 7.52 0 001.77 4.71A4.6 4.6 0 009.55 22H14v2h-3v2h15v-2h-3v-3.13zM16 9h12v9.13l-12 1.72zM9.55 20c-1.48 0-1.87-.28-2.31-.71C6.44 18.5 6 16.8 6 14.5s.44-4 1.24-4.77c.45-.44.85-.73 2.31-.73H14v11zM21 24h-5v-2.13l5-.72z" })));
}
exports.default = SvgPumpMcOutline;
//# sourceMappingURL=PumpMcOutline.js.map